module.exports = __webpack_public_path__ + "img/tu1-1.4db15f3c.png";